import React from "react";
import { PrimaryButton, SecondaryButton } from "@ui";
import { KontentPrimaryButton } from "@ui/PrimaryButton";
import { KontentSecondaryButton } from "@ui/SecondaryButton";

interface ButtonRendererProps {
  buttonData: KontentPrimaryButton | KontentSecondaryButton;
  className?: string;
}

const ButtonRenderer: React.FC<ButtonRendererProps> = ({
  buttonData,
  className,
}) => {
  if (buttonData.system?.type === "primary_button") {
    const primaryButton = buttonData as KontentPrimaryButton;
    return (
      <PrimaryButton
        internalText={primaryButton.elements.internal_text.value}
        externalText={primaryButton.elements.external_text.value}
        internalPath={primaryButton.elements.internal_path.value}
        externalUrl={primaryButton.elements.external_url.value}
        new_window={primaryButton.elements.new_window.value[0].codename}
        icon={primaryButton.elements.icon?.value[0]?.codename}
        className={className}
      />
    );
  } else {
    const secondaryButton = buttonData as KontentSecondaryButton;
    return (
      <SecondaryButton
        internalPath={secondaryButton.elements.internal_path?.value}
        externalUrl={secondaryButton.elements.external_url?.value}
        new_window={secondaryButton.elements.new_window.value[0]?.codename}
        variant={secondaryButton.elements.variant.value[0].codename}
        className={className}
      >
        {secondaryButton.elements.text?.value}
      </SecondaryButton>
    );
  }
};

export default ButtonRenderer;
